export const IS_PRODUCTION =
  import.meta.env.DEPLOYMENT_ENVIRONMENT === 'production';

export const IS_DEVELOPMENT =
  import.meta.env.DEPLOYMENT_ENVIRONMENT === 'development';

export const IS_TEST = import.meta.env.DEPLOYMENT_ENVIRONMENT === 'test';

export const IS_INTEGRATION =
  import.meta.env.DEPLOYMENT_ENVIRONMENT === 'integration';
